import { FormikValues, useField, useFormikContext } from "formik"
import {
    DeliveryPayloadType,
    IBasketMeetingPlanningFormField,
    IFormikSelectProps
} from "../../Types/MeetingPlanning/deliveryForm"
import React, { useCallback, useEffect, useState } from "react"
import { Localized } from "@fluent/react"
import {
    TEXT_FIELD_MAX_LENGTH,
} from "../../Static/MeetingPlanning/deliveryForm"
import {
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    makeStyles,
    MenuItem,
    Select,
    Typography
} from "@material-ui/core"
import { FormikTextField } from "./Formik"
import clsx from "clsx"
import { FormInputField } from "../../Modules/Forms/formTypes"
import AsteriskComponent from "../Layout/Asterisk"

const useStyles = makeStyles((theme) => ({
    mt_2: {
        marginTop: theme.spacing(2),
    },
    mb_1: {
        marginBottom: theme.spacing(1),
    },
    mb_2: {
        marginBottom: theme.spacing(2),
    },
    mb_3: {
        marginBottom: theme.spacing(3),
    },
    link: {
        textDecoration: "underline",
        width: "100%",
        textAlign: "center",
        fontWeight: 500,
        cursor: "pointer"
    },
    formSelect: {
        '& .MuiSelect-select:focus': {
            backgroundColor: 'transparent'
        }
    },
    formSelectWithoutLabel: {
        '& legend span': {
            display: 'none'
        }
    },
    placeholder: {
        color: theme.palette.text.disabled,
        fontStyle: 'normal',
    },
}))

interface IFormikDeliverySelectProps extends IFormikSelectProps {
    onDeliveryChange: (deliveryType: DeliveryPayloadType) => void
}

export const FormikDeliverySelectControl = ({ name, label, isFloatingLabel, required, placeholder, options, onDeliveryChange, ...props }: IFormikDeliverySelectProps) => {
    const classes = useStyles()
    const [field, meta] = useField(name)
    const { values } = useFormikContext()

    useEffect(() => {
        if ((values as FormikValues)?.[field.name]) {
            onDeliveryChange((values as FormikValues)?.[field.name])
        }
    }, [(values as FormikValues)?.[field.name]])

    return (
        <>
            {
                (label && !isFloatingLabel) && (
                    <Typography variant="body1" className={classes.mb_1}>
                        {label}
                        <AsteriskComponent required={required || false} />
                    </Typography>
                )
            }
            <FormControl fullWidth variant="outlined" error={meta.touched && Boolean(meta.error)}>
                {
                    label && isFloatingLabel && (
                        <InputLabel>
                            {label}
                            <AsteriskComponent required={required || false} />
                        </InputLabel>
                    )
                }
                <Select
                    {...field}
                    displayEmpty
                    className={clsx(classes.formSelect, { [classes.formSelectWithoutLabel]: label && !isFloatingLabel })}
                    label={label}
                    {...props}
                >
                    {placeholder && (
                        <MenuItem value="" disabled hidden>
                            <em className={classes.placeholder}>{placeholder}</em>
                        </MenuItem>
                    )}
                    {options.map((opt) => (
                        <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                        </MenuItem>
                    ))}
                </Select>
                {meta.touched && meta.error && (
                    <FormHelperText>{meta.error}</FormHelperText>
                )}
            </FormControl>
        </>
    )
}

export const OtherDeliveryControl = ({ field }: { field: FormInputField }) => {
    const classes = useStyles()

    const { values, setFieldValue } = useFormikContext<IBasketMeetingPlanningFormField>()
    const [choseOtherLocation, setChoseOtherLocation] = useState(false)


    const onChoseOtherLocation = useCallback(() => {
        setChoseOtherLocation(true)
        setFieldValue("hasOtherDeliveryLocation", true)
    }, [choseOtherLocation, setFieldValue])

    useEffect(() => {
        // @ts-ignore
        if (values?.DELIVERY_TYPE !== DeliveryPayloadType.DELIVERY) {
            setFieldValue("DELIVERY_LOCATIONS", [])
            setFieldValue(field.name, "")
            setChoseOtherLocation(false)
        }
        // @ts-ignore
    }, [values?.DELIVERY_TYPE])

    useEffect(() => {
        // @ts-ignore
        if (values?.DELIVERY_LOCATIONS?.length) {
            setChoseOtherLocation(false)
            setFieldValue("hasOtherDeliveryLocation", false)
            setFieldValue(field.name, "")
        }

        // @ts-ignore
    }, [values?.DELIVERY_LOCATIONS])

    return <Grid  item className={classes.mb_3}>
        {field?.isActive ? <Grid item className={clsx(classes.mt_2, classes.mb_2)}>
            {choseOtherLocation
                ? <Grid item>
                    <FormikTextField
                        fullWidth
                        type={'string'}
                        name={field.name}
                        variant={'outlined'}
                        title={field.title || ''}
                        label={field.label}
                        active={field.isActive}
                        required={field.required}
                        placeholder={field.placeholder}
                        helperText={field.helperText}
                        disabled={field.disabled}
                        inputProps={{ maxLength: TEXT_FIELD_MAX_LENGTH }}
                    />
                </Grid>
                : <Localized id="delivery-form-delivery-other-location-field-button">
                    <Typography variant="body1" className={classes.link} onClick={onChoseOtherLocation}>+ Andet leveringssted</Typography>
                </Localized>
            }
        </Grid> : null}
    </Grid>
}
